const dataTableData = {
  columns: [
    { Header: "#", accessor: "#", width: "5%" },
    // { Header: "ID", accessor: "id", width: "10%" },
    { Header: "اسم المرحلة", accessor: "name", width: "20%" },
    // { Header: "Description", accessor: "description", width: "25%" },
    { Header: "تاريخ البدأ", accessor: "startDate", width: "15%" },
    { Header: "تاريخ الانتهاء", accessor: "endDate", width: "15%" },
    // { Header: "Project ID", accessor: "projectId", width: "10%" },
    { Header: "الحالة", accessor: "status", width: "10%" },
    { Header: "نسبة الانجاز", accessor: "progress", width: "10%" },
    // { Header: "Project Name", accessor: "projectName", width: "15%" },
    { Header: "اجراء", accessor: "actions", width: "15%" },
  ],
  rows: [],
};

export default dataTableData;
